/* global window */
/* eslint react/no-danger: 0 */

import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import styleable from 'react-styleable';
import cloneDeep from 'lodash/cloneDeep';
import isEmpty from 'lodash/isEmpty';
import flow from 'lodash/flow';
import filter from 'lodash/filter';
import property from 'lodash/property';
import some from 'lodash/some';
import partialRight from 'lodash/partialRight';
import moment from 'moment';
import css from '../index.scss';
import Button from '../../button/index';
import { DARK } from '../../button/variants';
import messages from '../messages';
import DropDownList from '../../dropdown-list/index';
import { BORDERED } from '../../dropdown-list/constant';
import { dropdowns, buttons } from '../constants';
import CertificateTypes from '../components/certificate-summary';
import DatePickerComp from '../../../components/date-picker/index';
import { EMPTY_VALUE } from '../../../containers/download-certificates/constants';

const DownloadCertificatesForm = (props) => {
    const {
        academicYear,
        classes,
        classroomGroups,
        currentDate,
        downloadCertificates,
        fetchingAcademicYear,
        fetchingAcademicYearSuccess,
        fetchingClassroomGroups,
        fetchingSummary,
        fetchingSummarySuccess,
        isDownloading,
        onDatePickerChange,
        selectedTeacherId,
        selectedClassroomId,
        selectedGroupId,
        setClassroomId,
        setGroupId,
        setTeacherId,
        summary,
        teachers
    } = props;

    const { totalCount } = summary;

    const isDownlodButtonEnabled = (
        fetchingAcademicYear ||
        fetchingSummary ||
        isDownloading ||
        fetchingClassroomGroups ||
        totalCount === 0
    );

    let downloadButtonLabel = messages.downloadBtn;

    if (totalCount === 0) {
        downloadButtonLabel = messages.noCertsAvailable;
    }

    if (totalCount > 0) {
        downloadButtonLabel = messages.certsAvailable;
    }

    const certTypesProps = {
        currentDate,
        downloadCertificates,
        fetchingSummarySuccess,
        isDownloading,
        summary
    };

    const calendarProps = {
        isOutsideRange: day => (moment().diff(day) < 0)
    };

    const clonedTeachers = filter(cloneDeep(teachers), item => !isEmpty(item.assignedClassrooms));

    const clonedClasses = filter(cloneDeep(classes), item => !isEmpty(item.studentsProfileId));

    const hasTeacher = (selectedTeacherId !== EMPTY_VALUE || selectedTeacherId === undefined);

    const filteredClasses = !hasTeacher ? clonedClasses : filter(clonedClasses,
        flow(property('teachers'), partialRight(some, { userProfileId: parseInt(selectedTeacherId, 10) })
        ));

    const infoView = (<div className={css.downloadCertificatesComponent}>
        <div className={css.downloadCertificatesHeader}>
            {props.intl.formatMessage(messages.header)}
        </div>
        <div className={css.downloadCertificatesContent}>
            <div className={css.downloadCertificatesContentWrapper}>
                <DropDownList
                    customLabelFn={dropdowns.TEACHERS.customLabel}
                    disabled={teachers.length < 1}
                    name={dropdowns.TEACHERS.id}
                    onChange={setTeacherId}
                    optionKey={dropdowns.TEACHERS.key}
                    options={clonedTeachers}
                    placeholder={props.intl.formatMessage(messages.teachersDropdownLabel)}
                    value={selectedTeacherId}
                    variant={BORDERED}
                />
                <DropDownList
                    disabled={classes.length < 1}
                    name={dropdowns.CLASSES.id}
                    onChange={setClassroomId}
                    optionKey={dropdowns.CLASSES.key}
                    options={filteredClasses}
                    optionText={dropdowns.CLASSES.label}
                    placeholder={props.intl.formatMessage(messages.classesDropdownLabel)}
                    value={selectedClassroomId}
                    variant={BORDERED}
                />
                <DropDownList
                    disabled={selectedClassroomId === EMPTY_VALUE || classroomGroups.length < 1 || fetchingClassroomGroups}
                    name={dropdowns.GROUPS.id}
                    onChange={setGroupId}
                    optionKey={dropdowns.GROUPS.key}
                    options={classroomGroups}
                    optionText={dropdowns.GROUPS.label}
                    placeholder={props.intl.formatMessage(messages.groupsDropdownLabel)}
                    value={selectedGroupId}
                    variant={BORDERED}
                />
                <DatePickerComp
                    academicYear={academicYear}
                    currentDate={currentDate}
                    disabled={!fetchingAcademicYearSuccess}
                    onDateChange={onDatePickerChange}
                    reactDatesConfig={calendarProps} />
                <CertificateTypes {...certTypesProps} />
            </div>
        </div>
        <div className={css.downloadCertificatesFooter}>
            <Button
                containerClassName={buttons.DOWNLOAD.id}
                disabled={isDownlodButtonEnabled}
                handleOnClick={downloadCertificates}
                label={props.intl.formatMessage(downloadButtonLabel, { totalCount })}
                variant={DARK} />
        </div>
    </div>);

    return infoView;
};

DownloadCertificatesForm.propTypes = {
    academicYear: PropTypes.object,
    classes: PropTypes.arrayOf(PropTypes.object),
    classroomGroups: PropTypes.arrayOf(PropTypes.object),
    currentDate: PropTypes.object,
    downloadCertificates: PropTypes.func,
    fetchingAcademicYear: PropTypes.bool,
    fetchingAcademicYearSuccess: PropTypes.bool,
    fetchingClassroomGroups: PropTypes.bool,
    fetchingSummary: PropTypes.bool,
    fetchingSummarySuccess: PropTypes.bool,
    intl: intlShape.isRequired,
    isDownloading: PropTypes.bool,
    isSuccess: PropTypes.bool,
    onDatePickerChange: PropTypes.func,
    selectedTeacherId: PropTypes.string,
    selectedClassroomId: PropTypes.string,
    selectedGroupId: PropTypes.string,
    setClassroomId: PropTypes.func,
    setGroupId: PropTypes.func,
    setTeacherId: PropTypes.func,
    summary: PropTypes.object,
    teachers: PropTypes.arrayOf(PropTypes.object)
};

export default injectIntl(styleable(css)(DownloadCertificatesForm));



// WEBPACK FOOTER //
// ./app/components/download-certificates/pages/form.js